import { render, staticRenderFns } from "./flashSaleList.vue?vue&type=template&id=2ba9aab0"
import script from "./flashSaleList.vue?vue&type=script&lang=js"
export * from "./flashSaleList.vue?vue&type=script&lang=js"
import style0 from "./flashSaleList.vue?vue&type=style&index=0&id=2ba9aab0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports